import { AccordionSummary, Typography, AccordionDetails, Accordion } from '@mui/material'
import { RecommendationListContainer } from './containers/RecommendationListContainer'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

interface RecommendationsSectionProps {
    marketSpyId?: number,
    marketSpyRunResult?: any,
    onSelectedMonitorLaunchTaskChange?: (event: any) => void
}

export const RecommendationsSection = (props: RecommendationsSectionProps): JSX.Element => {
    const {
        marketSpyId,
        marketSpyRunResult,
        onSelectedMonitorLaunchTaskChange
    } = props

    const handleSelectedMonitorLaunchTaskChange = (event: any) => {
        onSelectedMonitorLaunchTaskChange?.(event)
    }

    return (
        <div>
            <Accordion disableGutters defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: '#FFF' }} />}
                    aria-controls="panel1a-content"
                    sx={{
                        backgroundColor: '#FFF',
                        flexDirection: 'row-reverse',
                        padding: {
                            xs: '8px 12px', md: '8px 24px'
                        },
                        '& .MuiAccordionSummary-expandIconWrapper': {
                            padding: '12px 12px 12px 12px',
                            fill: '#717171',
                            color: '#717171'
                        },

                        '& .MuiSvgIcon-root': {
                            fill: '#717171',
                            color: '#717171'
                        },

                        '& .MuiAccordionSummary-content': {
                            flexDirection: {
                                xs: 'column',
                                sm: 'row'
                            }
                        },

                    }}
                >
                    <Typography sx={
                        {
                            fontSize: {
                                xs: '24px',
                                sm: '24px',
                                md: '24px',
                            },
                            lineHeight: '28px',
                            color: '#000',
                            fontWeight: 600,
                            marginRight: 2
                        }
                    }
                    >
                        Recommendations
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ bgcolor: '#EEE', p: '8px' }}>
                    <RecommendationListContainer
                        marketSpyId={marketSpyId}
                        onSelectedMonitorLaunchTaskChange={handleSelectedMonitorLaunchTaskChange}
                        marketSpyRunResult={marketSpyRunResult}
                    />
                </AccordionDetails>
            </Accordion>     
        </div>
    )
}